import type { TableRowProps } from '@mui/material/TableRow';

import Stack from '@mui/material/Stack';
import Skeleton from '@mui/material/Skeleton';
import TableRow from '@mui/material/TableRow';
import TableCell from '@mui/material/TableCell';

// ----------------------------------------------------------------------

export function SalesTableSkeleton({ ...other }: TableRowProps) {
  return (
    <TableRow {...other}>
      <TableCell colSpan={12}>
        <Stack spacing={3} direction="row" alignItems="center" marginY={6}>
          <Skeleton sx={{ width: 180, height: 12 }} />
          <Skeleton sx={{ width: 0.8, height: 12 }} />
          <Skeleton sx={{ width: 200, height: 12 }} />
          <Skeleton sx={{ width: 200, height: 12 }} />
        </Stack>
        <Stack spacing={3} direction="row" alignItems="center" marginY={6}>
          <Skeleton sx={{ width: 180, height: 12 }} />
          <Skeleton sx={{ width: 0.8, height: 12 }} />
          <Skeleton sx={{ width: 200, height: 12 }} />
          <Skeleton sx={{ width: 200, height: 12 }} />
        </Stack>
        <Stack spacing={3} direction="row" alignItems="center" marginY={6}>
          <Skeleton sx={{ width: 180, height: 12 }} />
          <Skeleton sx={{ width: 0.8, height: 12 }} />
          <Skeleton sx={{ width: 200, height: 12 }} />
          <Skeleton sx={{ width: 200, height: 12 }} />
        </Stack>
      </TableCell>
    </TableRow>
  );
}

export function ComplianceTableSkeleton({ ...other }: TableRowProps) {
  return (
    <TableRow {...other}>
      <TableCell colSpan={12}>
        <Stack spacing={3} direction="row" alignItems="center" marginY={6}>
          <Skeleton sx={{ width: 0.1, height: 12 }} />
          <Skeleton sx={{ width: 0.4, height: 12 }} />
          <Skeleton sx={{ width: 0.3, height: 12 }} />
          <Skeleton sx={{ width: 0.1, height: 12 }} />
          <Skeleton sx={{ width: 0.1, height: 12 }} />
        </Stack>
        <Stack spacing={3} direction="row" alignItems="center" marginY={6}>
          <Skeleton sx={{ width: 0.1, height: 12 }} />
          <Skeleton sx={{ width: 0.4, height: 12 }} />
          <Skeleton sx={{ width: 0.3, height: 12 }} />
          <Skeleton sx={{ width: 0.1, height: 12 }} />
          <Skeleton sx={{ width: 0.1, height: 12 }} />
        </Stack>
        <Stack spacing={3} direction="row" alignItems="center" marginY={6}>
          <Skeleton sx={{ width: 0.1, height: 12 }} />
          <Skeleton sx={{ width: 0.4, height: 12 }} />
          <Skeleton sx={{ width: 0.3, height: 12 }} />
          <Skeleton sx={{ width: 0.1, height: 12 }} />
          <Skeleton sx={{ width: 0.1, height: 12 }} />
        </Stack>
      </TableCell>
    </TableRow>
  );
}

export function PerformanceTableSkeleton({ ...other }: TableRowProps) {
  return (
    <TableRow {...other}>
      <TableCell colSpan={12}>
        <Stack spacing={3} direction="row" alignItems="center" marginY={6}>
          <Skeleton sx={{ width: 0.2, height: 12 }} />
          <Skeleton sx={{ width: 0.15, height: 12 }} />
          <Skeleton sx={{ width: 0.15, height: 12 }} />
          <Skeleton sx={{ width: 0.15, height: 12 }} />
          <Skeleton sx={{ width: 0.15, height: 12 }} />
          <Skeleton sx={{ width: 0.2, height: 12 }} />
        </Stack>
        <Stack spacing={3} direction="row" alignItems="center" marginY={6}>
          <Skeleton sx={{ width: 0.2, height: 12 }} />
          <Skeleton sx={{ width: 0.15, height: 12 }} />
          <Skeleton sx={{ width: 0.15, height: 12 }} />
          <Skeleton sx={{ width: 0.15, height: 12 }} />
          <Skeleton sx={{ width: 0.15, height: 12 }} />
          <Skeleton sx={{ width: 0.2, height: 12 }} />
        </Stack>
        <Stack spacing={3} direction="row" alignItems="center" marginY={6}>
          <Skeleton sx={{ width: 0.2, height: 12 }} />
          <Skeleton sx={{ width: 0.15, height: 12 }} />
          <Skeleton sx={{ width: 0.15, height: 12 }} />
          <Skeleton sx={{ width: 0.15, height: 12 }} />
          <Skeleton sx={{ width: 0.15, height: 12 }} />
          <Skeleton sx={{ width: 0.2, height: 12 }} />
        </Stack>
      </TableCell>
    </TableRow>
  );
}
